import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ssoClientsKeys } from "Api/Queries/SsoClients/useSsoClientsQuery";
import {
  putSsoClientsClientId,
  type SsoClientDto,
  type SsoClientRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SsoClientDto) => void;
  onError?: (error: unknown) => void;
};

type Variables = {
  clientId: string;
  data: SsoClientRequest;
};

export const useUpdateSsoClientMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ clientId, data }: Variables) => putSsoClientsClientId(data, clientId),
    ),
    onSuccess: (data: SsoClientDto) => {
      queryClient.invalidateQueries({ queryKey: ssoClientsKeys.all });
      onSuccess?.(data);
    },
    onError,
  });
};
